import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Colors } from "src/assets/colors/Colors";
import { currencyFormatter } from "src/util/functions";
import Tooltip from "@mui/material/Tooltip";
import AgGridTable from "src/components/AgGridTable";
import { alertQuestionService } from "src/services/alertQuestionService";
import { productosService } from "src/services/unoauno/apiProductos";
import { modalCRUDService } from "src/services/modalCRUDService";
import { GlobalConstants } from "src/data/GlobalConstants";
import CellRendererState from "src/components/CellRenderers/CellRendererState";
import CellRendererStateCrearEditar from "src/components/CellRenderers/CellRendererStateCrearEditar";

const COLUMN_DEF = [
    {headerName: "Acción", field: "edit", cellRenderer: 'stateCrearEditar', minWidth: 70, resizable: true, sortable: false, filter: false},
    {headerName: "Proveedor", field: "Proveedor", minWidth: 100, resizable: true, sortable: false, filter: false},
    {headerName: "Negocio", field: "Negocio", minWidth: 100, resizable: true, sortable: false, filter: false},
    {headerName: "Codigo Producto", field: "Codigo Producto", minWidth: 140, resizable: true, sortable: false, filter: false},
    {headerName: "Estado en el distribuidor", field: "Estado en el distribuidor", cellRenderer: 'state', minWidth: 150, resizable: true, sortable: false, filter: false},
    {headerName: "Estado en la aplicacion", field: "Estado en la aplicacion", cellRenderer: 'state', minWidth: 150, resizable: true, sortable: false, filter: false},
    {headerName: "Orden", field: "Orden", minWidth: 70, resizable: true, sortable: false, filter: false},
    {headerName: "Nombre Producto", field: "Nombre Producto", minWidth: 300, resizable: true, sortable: false, filter: false},
    {headerName: "Valor Producto", field: "Valor Producto", valueFormatter: currencyFormatter, cellClass: 'number-cell', minWidth: 150, resizable: true, sortable: false, filter: false},
    {headerName: "Iva %", field: "Iva %", minWidth: 70, resizable: true, sortable: false, filter: false},
    {headerName: "Precio con descuento", field: "Precio con descuento", valueFormatter: currencyFormatter, cellClass: 'number-cell', minWidth: 160, resizable: true, sortable: false, filter: false},
    {headerName: "Precio Sugerido", field: "Precio Sugerido", valueFormatter: currencyFormatter, cellClass: 'number-cell', minWidth: 150, resizable: true, sortable: false, filter: false},
    {headerName: "Evento", field: "Evento", cellRenderer: 'state', minWidth: 110, resizable: true, sortable: false, filter: false},
    {headerName: "Fecha Inicio", field: "Fecha Inicio", minWidth: 110, resizable: true, sortable: false, filter: false},
    {headerName: "Fecha Fin", field: "Fecha Fin", minWidth: 110, resizable: true, sortable: false, filter: false},
];

const TableExcelProductos = ({properties}) => {
    const { data, onPressAccept, file } = properties;
    const dispatch = useDispatch();
    const tableRef = useRef(null);

    const [statePressButton, setStatePressButton] = useState(false)

    const countEditarRef = useRef(null);
    const countCrearRef = useRef(null);

    useEffect(() => {
        countEditarRef.current.innerText = data.filter(el => el.edit).length;
        countCrearRef.current.innerText = data.filter(el => !el.edit).length;
    }, []);

    const saveExcel = () => {
        alertQuestionService.showAlert({
            title: `Guardar información de Excel`, question: `¿Estás seguro de guardar?`,
            message: `Ten en cuenta que algunos productos se podrán editar y otros crear.`,

            actionBtnAceptar: async () => {
                alertQuestionService.clear();

                setStatePressButton(true)

                try {
                    const res = await productosService.saveCargueExcel({data, file})

                    if(!res.status){
                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning, message: res.msg } });
                    }else {
                        onPressAccept()
                    }
                    
                    modalCRUDService.clear()
                } catch (error) {
                    console.log(error)
                }
            },
            actionBtnCancelar: () => alertQuestionService.clear(),
            type: GlobalConstants.alertInfo
        })
    }

    const getRowStyle = (params) => {  
        if (params.data.precioMaestro == 0) return {}

        const porcentaje = params.data.usaPorcentajeDistribuidor == 1 ? params.data.porcentajeDistribuidor : params.data.porcentajeComparacion;
        
        if(Number(params.data['Valor Producto']) < Number(params.data.precioMaestro) * (1 - (Number(porcentaje) / 100))) return { backgroundColor: Colors.COLOR_CELL_ERROR }
        if(Number(params.data['Valor Producto']) > Number(params.data.precioMaestro) * (1 + (Number(porcentaje) / 100))) return { backgroundColor: Colors.COLOR_CELL_SUCCESS }
    
        return {}
    }

    return(
        <React.Fragment>
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center w-75 pl-3">
                    <div>
                        <strong className="mr-2">Crear:</strong>
                        <span ref={countCrearRef} style={{fontSize: 20, color: Colors.GREEN_SWITCH_ACTIVE, fontWeight: 'bold'}}> 0</span>
                    </div>
                    <div className="ml-4">
                        <strong className="mr-2">Actualizar:</strong>
                        <span ref={countEditarRef} style={{fontSize: 20, color: Colors.AMARILLO_MOSTAZA, fontWeight: 'bold'}}> 0</span>
                    </div>
                </div>
                <div className={`d-flex align-items-center ${statePressButton ? 'is-disabled' : ''}`}>
                    <Tooltip title="Guardar" aria-label="guardar" >
                        <a className="icon-container-actions d-flex "
                        onClick={saveExcel}>
                            <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                            <i style={{color: Colors.COLOR_GREEN_DARK}} className="far fa-save fa-2x"/>
                        </a>
                    </Tooltip>
                </div>
            </div>
            <AgGridTable
                referencia={tableRef}
                columnDef={COLUMN_DEF}
                dataList={data}
                getRowStyle = {getRowStyle}
                frameworkComponents={{
                    state: CellRendererState,
                    stateCrearEditar: CellRendererStateCrearEditar
                }}
                onGridReady={params => params.api.sizeColumnsToFit()}
            />
        </React.Fragment>
    )
}

export default TableExcelProductos